(() => {
  const curtain = document.querySelector(".page-transition");
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelector(".menu-button")?.addEventListener("click", (event) => {
    const button = event.currentTarget;
    const nav = document.querySelector(".primary-nav");
    const open = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!open));
    nav?.classList.toggle("is-open", !open);
  });
  if (sessionStorage.getItem("sp-arrive") && !reduced) {
    sessionStorage.removeItem("sp-arrive");
    curtain?.classList.add("arriving");
    window.setTimeout(() => curtain?.classList.remove("arriving"), 900);
  }
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a.animated-link");
    if (!link || reduced || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname === window.location.pathname) return;
    event.preventDefault();
    sessionStorage.setItem("sp-arrive", "1");
    curtain?.classList.add("leaving");
    window.setTimeout(() => { window.location.href = url.href; }, 620);
  });
})();
